import API from "./axios";

/**
 * Support tickets — every ERP login can raise one; support (the SUPER_ADMIN
 * logins) answers. WHO SEES WHAT is decided on the server: support sees every
 * company, the company owner his company, anyone else his own tickets. The
 * detail carries `can*` flags saying what the viewer may do right now, so the
 * page never re-derives the role and status rules.
 *
 * Screenshots are uploaded first — uploadImage(file) → { id, url } — and
 * their ids sent with the ticket or the message (`attachmentIds`).
 *
 * `config` lets a background refresh pass { silent: true } so it does not
 * flash the top progress bar (see axios.js).
 */
export const supportTicketApi = {
  list: (config) => API.get("/support-tickets", config),
  /** { unread, actionNeeded } — the top-bar badge. Always silent: it polls. */
  counts: () => API.get("/support-tickets/unread-count", { silent: true }),
  /** The ticket with its conversation; opening it marks it read. */
  get: (id, config) => API.get(`/support-tickets/${id}`, config),
  create: (body) => API.post("/support-tickets", body),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return API.post("/support-tickets/attachments", fd, {
      headers: { "Content-Type": undefined },
    });
  },
  /** Remove a screenshot uploaded for a message that was not sent. */
  discardImage: (attachmentId) => API.delete(`/support-tickets/attachments/${attachmentId}`),
  /**
   * A comment (raiser / owner) or a support reply. Support may pass
   * status: IN_PROGRESS | WAITING_ON_USER | RESOLVED | CLOSED.
   */
  message: (id, body) => API.post(`/support-tickets/${id}/messages`, body),
  reopen: (id, body) => API.patch(`/support-tickets/${id}/reopen`, body),
  close: (id, body) => API.patch(`/support-tickets/${id}/close`, body || {}),
  priority: (id, priority) =>
    API.patch(`/support-tickets/${id}/priority?priority=${encodeURIComponent(priority)}`),
};

export default supportTicketApi;
